import React, { createContext, useContext } from 'react';

import { EMAIL_NOTIFICATION_TYPE } from 'components/Settings/constants';

import { SHARE_MODAL_TABS } from './constants';
import { User } from './types';
import { STATUS } from '../../../constants';

export type TabData = {
  emails: string[];
  selectedUsers: User[];
  note?: string;
  views?: number[];
  selectedCompetitors?: number[];
};

export const createDefaultTabData = (): TabData => ({
  emails: [],
  selectedUsers: [],
  note: '',
  views: [],
  selectedCompetitors: [],
});

export const getTabDataOrDefault = (tabData?: TabData): TabData => ({
  ...createDefaultTabData(),
  ...(tabData ?? {}),
});

export const createDefaultNotificationsTabData = (): Record<number, TabData> => ({
  [EMAIL_NOTIFICATION_TYPE.MARKET_INTELLIGENCE_DIGEST]: createDefaultTabData(),
  [EMAIL_NOTIFICATION_TYPE.ONLINE_REVIEWS_DIGEST]: createDefaultTabData(),
  [EMAIL_NOTIFICATION_TYPE.SALES_BATTLECARD_DIGEST]: createDefaultTabData(),
});

type ShareViaEmailContent = {
  loading: string;
  activeTab: string;
  notificationType: number;
  users: User[];
  shareTabData: TabData;
  notificationsTabData: Record<number, TabData>;
  setNotificationType: (value: number) => void;
  updateShareTabData: (data: Partial<TabData>) => void;
  updateNotificationTabData: (notificationType: number, data: Partial<TabData>) => void;
  handleClose: () => void;
  handleSend: () => void;
  handleSelect: (value: number) => void;
  handleSelectAll: () => void;
  handleDeselect: (value: number) => void;
  handleUserSearch: (event: any) => void;
};

export const defaultTabData: TabData = createDefaultTabData();

const defaultNotificationsTabData: Record<number, TabData> = createDefaultNotificationsTabData();

export const ShareViaEmailContext = createContext<ShareViaEmailContent>({
  loading: STATUS.IDLE,
  activeTab: SHARE_MODAL_TABS.SHARE,
  notificationType: EMAIL_NOTIFICATION_TYPE.MARKET_INTELLIGENCE_DIGEST,
  users: [],
  shareTabData: defaultTabData,
  notificationsTabData: defaultNotificationsTabData,
  setNotificationType: () => {
    // Do Nothing
  },
  updateShareTabData: () => {
    // Do Nothing
  },
  updateNotificationTabData: () => {
    // Do Nothing
  },
  handleClose: () => {
    // Do Nothing
  },
  handleSend: () => {
    // Do Nothing
  },
  handleSelect: () => {
    // Do Nothing
  },
  handleSelectAll: () => {
    // Do Nothing
  },
  handleDeselect: () => {
    // Do Nothing
  },
  handleUserSearch: () => {
    // Do Nothing
  },
});

export const useShareViaEmailContext = () => useContext(ShareViaEmailContext);
